import React, { FunctionComponent } from 'react';
import classnames from 'classnames';
import styles from './FormLabel.scss';

type FormLabelProps = {
    children?: React.ReactNode;
    htmlFor?: string;
    hideLabel?: boolean;
};

export const FormLabel: FunctionComponent<FormLabelProps> = ({ htmlFor, children }) =>
    !children ? null : (
        <label htmlFor={htmlFor} className={classnames(styles.label)}>
            {children}
        </label>
    );
